import err404 from '@/screens/errors/404'
import err403 from '@/screens/errors/403'

const routes = [
  {
    path: '/403',
    name: '403',
    component: err403
  },
  {
    path: '/404',
    name: '404',
    component: err404
  }
]

export default routes
